import React, { useEffect, useRef, useState } from "react";
import { Box, Button, Card, CardActions, CardContent, FormControl, FormControlLabel, FormGroup, Input, InputLabel, Stack, Switch, Typography } from "@mui/material";
import { Dialog } from "@mui/material";
import { red, amber, darkGreen } from "../../shared/colours";
import ragService from "../../services/ragService";
import { ThumbUp, Warning } from "@mui/icons-material";

const RiskCardModal = (props) => {
	
	const notes = useRef(null);
	let [ complete, setComplete ] = useState(props.risk && props.risk.complete === 1);
	
	// useEffect(() => {
	// 	setComplete(props.risk && props.risk.complete === 1);
	// }, []);
	
	useEffect(() => {
		setComplete(props.risk && props.risk.complete === 1);
	}, [props.risk]);
	
	const handleClose = () => {
		props.onClose()
	};
	
	const parseDescriptionLong = (risk) => {
		let description = risk.description_long;
		description = description.split("\nAdditionally")[0];
		description = description.split("If you have any questions")[0];
		description = description.replaceAll("KYND", "Cymplify");
		return description.split("\n");
	};
	
	const parseHistoryDescription = (item) => {
		let description = item.description_short;
		description = description.replaceAll("KYND", "Cymplify");
		return description.split("\n");
	};
	
	let headerColor = "";
	let headerTitle = "";
	if (props.risk && props.risk.severity === 2) {
		headerColor = red;
		headerTitle = "High Risk";
	}
	if (props.risk && props.risk.severity === 1) {
		headerColor = amber;
		headerTitle = "Medium Risk";
	}
	if (props.risk && props.risk.severity === 0) {
		headerColor = darkGreen;
		headerTitle = "Low Risk";
	}
	
		
	const handleUpdate = async () => {
		await ragService.setComplete(props.risk.id, complete? 1 : 0, notes.current.value);
		setComplete(false);
		props.onClose(true);
	};
	
	const handleSubmitForm = (e) => {
		e.preventDefault();
		handleUpdate();
	};
	
	const handleCompleteSwitch = (e) => {
		setComplete(e.target.checked);
	};

	const getTechnicalDetails = () => {
		let technicalDetails = {};
		if (typeof props.risk.kynd_data.templateValues === "object") {
			for (const [k, v] of Object.entries(props.risk.kynd_data.templateValues)) {
				if (props.risk.company_id === 108) continue;
				if (Array.isArray(v)) continue;
				if (k === "serviceId") continue;
				if (typeof v === "object") continue;

				technicalDetails[k] = (v === null)? "N/A" : v.toString();
			}
		}
		
		if (!technicalDetails.hasOwnProperty("domain")) {
			technicalDetails.domain = props.risk.address;
		}

		return technicalDetails;
	};
	
	const borderedSection = {
		border: "1px solid",
		borderRadius: "1em",
		borderColor: "text.primary",
		margin: "0.5em",
		padding: "0.5em"
	};
	
	const sectionHeader = {
		fontWeight: "bold",
		fontSize: "1.5em",
		textAlign: "center"
	};
	
	const capitalizeFirstLetter = (string) => {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	const colorFromSeverity = (severity) => {
		switch (severity) {
			case 2:
				return red;
			case 1:
				return amber;
			default:
				return darkGreen;
		}
	}
	
	return (
		<Dialog
			open={props.risk? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
			maxWidth="lg"
			PaperProps={{ sx: { maxHeight: "98%" } }}
		>
			<Card
				sx={{
					flexGrow: 1,
					border: "2px",
					position: "relative",
					height: "100%",
					margin: "0.5em",
					backgroundColor: "background.card",
					boxShadow: "none",
					overflowY: "auto" 
				}}
			> 
					{(props.risk)?
					<CardContent>
						<Stack direction="column">
							<Box sx={{
								background: headerColor,
								borderRadius: "1em",
								padding: "1.25em",
								textAlign: "center",
								fontWeight: "bold",
								color: "#fff",
								margin: "0.5em"
							}}>
								<Typography sx={{
									textAlign: "center",
									fontWeight: "bold",
									fontSize: "2.75em",
									color: "#fff",
									lineHeight: "1em"
								}}>
									{headerTitle}
								</Typography>
								<Typography sx={{
									textAlign: "center",
									fontWeight: "bold",
									fontSize: "1.35em",
									color: "#fff"
								}}>
									{props.risk.title}
								</Typography>
							</Box>
							<Stack direction="row" sx={{ marginTop: "0.5em" }}>
								<Stack direction="column" sx={{ width: "67%" }}>
									<Stack direction="row">
										<Stack direction="column" sx={{ width: "50%", ...borderedSection }}>
											<Typography sx={{ ...sectionHeader }}>
												Exposure
											</Typography>
											<Stack direction="row" sx={{
												backgroundColor: "background.category",
												borderRadius: "1em",
												padding: "0.5em 2em",
												margin: "0.75em 2em"
											}}>
												{headerColor === darkGreen? <ThumbUp/> : <Warning/>}
												<Typography sx={{
													fontWeight: "bold",
													marginLeft: "1em"
												}}>
													{capitalizeFirstLetter(props.risk.category)}
												</Typography>
											</Stack>
										</Stack>
										<Stack
											direction="column"
											sx={{
												width: "50%",
												...borderedSection,
												paddingLeft: "1em",
												paddingRight: "1em",
												paddingBottom: "1em"
											}}
										>
											<Typography sx={{ ...sectionHeader, marginBottom: "1em" }}>
												Technical Details
											</Typography>
											{Object.entries(getTechnicalDetails()).map(([ k, v ], i) => {
												return (
												<Stack direction="row" spacing="0.5em" sx={{ marginRight: "1em"}}>
													<Typography key={`tech_k_${i}`} sx={{fontWeight: "bold" }}>
														{`${k.toString()}:`}
													</Typography>
													<Typography key={`tech_v_${i}`} sx={{ marginRight: "0.5em" }}>
														{v.toString()}
													</Typography>
												</Stack>
												);
											})}
										</Stack>
									</Stack>
									<Stack direction="column" sx={{ ...borderedSection, border: "0px" }}>
										{parseDescriptionLong(props.risk).map((part, i) => {
											return (
												<Typography
													key={`riskpart_${i}`}
													sx={{ marginTop: "0.5em" }}
													dangerouslySetInnerHTML={{__html: part}}
												>
												</Typography>
											);
										})}
										<form
											onSubmit={handleSubmitForm}
											autoComplete="off"
											sx={{
												marginTop: "2em"
											}}
										>
											<FormGroup sx={{ marginTop: "1em" }}>
												<FormControlLabel
													control={
														<Switch
															checked={complete}
															onChange={handleCompleteSwitch}
														/>
													}
													label="Mark as Complete"
												/>
											</FormGroup>
											<FormControl sx={{ marginTop: "0.5em", width: "100%" }}>
												<InputLabel htmlFor="notes">Notes</InputLabel>
												<Input
													multiline={true}
													rows={2}
													inputRef={notes}
													id="notes"
													type="text"
													autoComplete="off"
													defaultValue={props.risk? props.risk.notes : ""}
												/>
											</FormControl>
										</form>
									</Stack>
								</Stack>
								<Stack direction="column" sx={{ width: "33%", ...borderedSection }}>
									<Typography sx={{ ...sectionHeader }}>
										Risk History
									</Typography>
									{(props.risk.history.length > 0)?
										<>
											<Box sx={{
												height: "35em",
												overflowX: "hidden",
												overflowY: "auto",
											}}>
												{props.risk.history.map((item, i) => {
													return (
														<Stack key={`riskhistoryitem_${i}`} direction="column" sx={{
															border: `1px solid ${colorFromSeverity(item.severity)}`,
															borderRadius: "0.5em",
															margin: "0.5em 0.5em",
															padding: "0.5em"
														}}>
															<Typography sx={{
																fontWeight: "bold",
																color: colorFromSeverity(item.severity)	
															}}>
																{item.kynd_updated.split("T")[0]}: {item.title}
															</Typography>
															{parseHistoryDescription(item).map((part, i) => {
																return (
																	<Typography
																		key={`riskpart_${i}`}
																		sx={{ margin: "0.5em 0" }}
																		dangerouslySetInnerHTML={{__html: part}}
																	>
																	</Typography>
																);
															})}
														</Stack>
													);
												})}
											</Box>
										</>
										:
										<>
											<Typography variant="h6" sx={{
												marginTop: "1em",
												marginBottom: "0.25em"
											}}>
												No History Available
											</Typography>
										</>
									}
								</Stack>
							</Stack>
						</Stack>
					</CardContent>
					: <CardContent/> }
				<CardActions>
					<Stack direction="row" justifyContent="space-between" sx={{ width: "100%" }}>
						<Button onClick={handleUpdate} size="small">Update</Button>
						<Button onClick={handleClose} size="small">Close</Button>
					</Stack>
				</CardActions>
			</Card>
		</Dialog>
	);
};

export default RiskCardModal;
